import React, { useContext, useCallback } from "react";
import {
  AppBar,
  Toolbar,
  CssBaseline,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { KeycloackContext } from "../../services/keycloakProvider"
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { AppContext } from "../context";
import { LOCALES } from "../../i18n";
import { default as translate } from '../../i18n/translate'

const useStyles = makeStyles((theme) => ({
  navlinks: {
    marginLeft: theme.spacing(10),
    display: "flex",
  },
 logo: {
    flexGrow: "1",
    cursor: "pointer",
  },
  link: {
    display: "flex",
    textDecoration: "none",
    color: "white",
    fontSize: "1.2rem",
    width: "13rem",
    marginTop: "0.5rem",
    "&:hover": {
      color: "#8EBF55",
    },
  },
}));

export default function Navbar() {
  const {state, dispatch} = useContext(AppContext);
  const classes = useStyles();
  const { logout } = useContext(KeycloackContext)
  const [alignment, setAlignment] = React.useState('web');

  const setLanguage = useCallback((locale) => {
    dispatch({
      type: 'setLocale',
      locale
    })
  },[dispatch])

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  return (
    <AppBar position="static" style={{ background: '#307B5B', width: "100%" }}>
      <CssBaseline />
      <Toolbar>
        <Typography variant="h4" className={classes.logo}>
        {translate("navbar.ami")}
        </Typography>
          <div className={classes.navlinks}>
            <Link to="/" className={classes.link}>
              {translate("navbar.accueil")}
            </Link>
            <Link to="/questionnaire" className={classes.link}>
              {translate("navbar.commencer")}
            </Link>
            <Link to="/capsules" className={classes.link}>
              {translate("navbar.capsule")}
            </Link>
            <Link to="/strategies" className={classes.link}>
              {translate("navbar.strategie")}
            </Link>
            <Link to="/contact" className={classes.link}>
              {translate("navbar.contact")}
            </Link>
            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleChange}
              aria-label="Platform"
              style={{backgroundColor: "white", width: "4.4rem"}}
            >
              <ToggleButton disabled={state.locale === LOCALES.FRENCH} onClick={() => setLanguage(LOCALES.FRENCH)} style={{padding: "0.5rem", fontWeight: "bold"}} value="french">FR</ToggleButton>
              <ToggleButton disabled={state.locale === LOCALES.ENGLISH} onClick={() => setLanguage(LOCALES.ENGLISH)} style={{padding: "0.5rem", fontWeight: "bold"}} value="english">EN</ToggleButton>
            </ToggleButtonGroup>
            <Link to="/" onClick={() => logout()} className={classes.link} style={{marginLeft: "7rem"}}>
              {translate("navbar.deconnection")}
            </Link>
          </div>
      </Toolbar>
    </AppBar>
  );
}